import { useState } from "react";
import {  Drawer,  DrawerContent,  DrawerHeader,  DrawerBody,  DrawerFooter} from "@heroui/drawer";
import { Button } from "@heroui/button";
import { Input } from "@heroui/input";
import { useNavigate } from "react-router-dom";
import { useSession } from "@clerk/clerk-react";
import { createMeetQuick as createMeetQuickApi } from "@/api/meets";
import { getCurrentTime, getNextAvailable15MinTime } from "@/utils/dates";

const CreateQuickMeetsDrawer = ({_show, _setShow}) => {
const navigate = useNavigate();
const { session } = useSession();

const [eventName, setEventName] = useState("");
const [loading, setLoading] = useState(false)

async function onCreateClick() {
    if(eventName === ''){
        return;
    }

    setLoading(true)
    const token = await session.getToken();
    const current_time = getCurrentTime()
    const end_time = getNextAvailable15MinTime()
    const payload = {
        'title': eventName,
        'start_time': current_time,
        'end_time': end_time
    }
    createMeetQuickApi(payload, token).then((_resp) => {
        if(_resp.data.Result === 'SUCCESS'){
            const short_code = _resp.data.ShortCode
            navigate(`/meetings/join/${short_code}`)
        }
    }).catch((_resp) => {
        console.log(_resp)
    }).finally(() => {
        setLoading(true)
    })
}

return (<>
<Drawer className="rounded-xl" placement="bottom" size="sm" shouldBlockScroll hideCloseButton={false} classNames={{ backdrop: "bg-black/30" }} backdrop={"blur"} isOpen={_show} onOpenChange={(_show) => {if (!_show) _setShow(false);}}>
<DrawerContent>
    <DrawerHeader className="flex items-center gap-3">
        <span className="font-medium">Quick Meets</span>
    </DrawerHeader>
    <div className="px-4 py-2">
    <Input placeholder="Enter event name" value={eventName} onChange={(e) => setEventName(e.target.value)} 
    classNames={{
        inputWrapper: `
            bg-white border border-neutral-200 hover:bg-neutral-50 rounded-xl shadow-sm
            dark:bg-content1/70 dark:border-default-200/60 dark:hover:bg-content2/60 dark:shadow-none
            focus:outline-none focus:ring-0
            data-[focus=true]:ring-0 data-[focus=true]:outline-none data-[focus=true]:border-neutral-300
        `,
        input: `
            text-neutral-900 placeholder:text-neutral-400 text-base
            dark:text-foreground focus:outline-none focus:ring-0
        `,
        }}/>
    </div>
    <DrawerFooter className="gap-3">
        <Button onPress={() => {onCreateClick()}} isLoading={loading} disabled={loading} variant="solid" className="w-full mb-2" color="primary" >
            {loading? 'Creating' : 'Create'}
        </Button>
    </DrawerFooter>
</DrawerContent>
</Drawer>
</>)
}

export default CreateQuickMeetsDrawer